import api from "src/api/index";
import {STATE_MEDIA} from "src/config";

export async function getPromotionsHints(){
    try {
        const response =  await api.get(STATE_MEDIA + "api/dashboard/hints-promotions")
        return response.data?.items ?? []
    } catch (error) {
        console.error("ошибка загрузки акций", error?.message)
    }
}

